import React, { FC } from "react";
import { Snackbar as MuiSnackbar } from "@mui/material";

type Props = React.ComponentProps<typeof MuiSnackbar>;

const Snackbar: FC<Props> = (props) => {
    return <MuiSnackbar {...props}/>
}

export default Snackbar;